import api from './api';

export default {
  fetchAll(params) {
    const url = '/health-screening-test-specs';
    return api.get(url);
  },
};
